import { PriceListContent } from '@/app/panel/management/price-list/_components/content'
import { PriceListHeader } from '@/app/panel/management/price-list/_components/header'
import { PriceListContextProvider } from '@/app/panel/management/price-list/_contexts/price-list-context'

export const ManagementPriceListPage = () => (
  <PriceListContextProvider>
    <PriceListHeader />

    <PriceListContent />
  </PriceListContextProvider>
)
